import httpClient from './httpClient';

export default {
  logModalImpression: ({ product, apiKey, externalId, payload }) =>
    httpClient.post(`/api/modal_impression/${product}/${apiKey}/${externalId}`, payload),
  logModalInteraction: ({ product, apiKey, externalId, payload }) =>
    httpClient.post(`/api/modal_interaction/${product}/${apiKey}/${externalId}`, payload),
  logModalElementRendered: ({ product, apiKey, externalId, payload }) =>
    httpClient.post(`/api/modal_element_rendered/${product}/${apiKey}/${externalId}`, payload),
  logWidgetInteraction: ({ product, apiKey, externalId, payload }) =>
    httpClient.post(`/widget_interaction/${product}/${apiKey}/${externalId}`, payload, {
      baseURL: process.env.VUE_APP_AV_INTEGRATIONS_BASE_URL,
    }),
};
